// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../Config.bs.js";
import * as CrmNetwork from "../../../../library/network/CrmNetwork.bs.js";
import * as CountryConfig from "../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as PretendAsCallerRepoConfig from "./PretendAsCallerRepoConfig.bs.js";

function fetchCallerDetails(caller_number, country) {
  var url = Config.Env.getHostName(undefined) + ("/administrators/incoming_calls_v3?phone=" + caller_number);
  return CrmNetwork.get(url, undefined, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(PretendAsCallerRepoConfig.PretendAsCallerResponseConverter.execute, result);
                        });
            });
}

var PretendAsCallerRepo = {
  fetchCallerDetails: fetchCallerDetails
};

export {
  PretendAsCallerRepo ,
  
}
/* Config Not a pure module */
